<div class="content d-flex flex-column gap-4">
  @if (currentPage(); as currentPage) {
    <wb-heading size="l" tag="h1">{{ currentPage.title }}</wb-heading>
    <wb-tabs [selected]="currentPage.slug">
      @for (page of legalPages(); track page.slug) {
        <wb-tab [name]="page.slug" [routerLink]="'../' + page.slug" [state]="{ scrollRestoration: 'top' }">
          {{ page.title }}
        </wb-tab>
      }
    </wb-tabs>
    @if (currentPage.slug !== 'settings') {
      <div class="legal-content" [innerHTML]="currentPage.bypassedBody"></div>
    } @else {
      <mb-setting-component-template></mb-setting-component-template>
    }
  } @else {
    <wb-skeleton id="heading"></wb-skeleton>
    <wb-skeleton id="tabs"></wb-skeleton>
    <wb-skeleton id="content"></wb-skeleton>
  }
</div>
